module.exports = __webpack_public_path__ + "images/bug_turquoise_large_42aa434aebf310fec9bdcbf342c402cd.png";